module.exports = __webpack_public_path__ + "static/media/Subscription SPANISH Agreement Final PofP HCPs Nov 06 2023.84333771.pdf";